








import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ColumnType } from '~/types/solepro/PageBuilder';

export default defineComponent({
    name: "Column",
    mixins: [PageBuilderComponent],
    components: {
        PageBuilderComponent
    },
    props: {
        node: {
            type: Object as PropType<ColumnType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props;
        const WrapperComponent = content.tagname.toLowerCase();

        return {
            WrapperComponent,
            content,

        }
    }
})
